// extracted by mini-css-extract-plugin
module.exports = {"container":"move-file-modal_container__5r4ja","folders":"move-file-modal_folders__tVn2Q"};